const { IoCloseCircleOutline } = require("react-icons/io5");

const CrossIconButton = ({ onClick }) => {
    return (
      <i
        onClick={onClick}
        className="bi bi-x-circle"
        style={{ cursor: 'pointer', marginLeft: '8px', marginTop:'6px', color: 'red', fontSize: '18px' }}
      >
        <IoCloseCircleOutline />
      </i>
    );
}

export default CrossIconButton